import type {
    ReactiveFormSupportDataPhase,
    ReactiveFormSupportDataSource,
} from '@fitogest/reactive-form-builder/interfaces';
import type { TransaccionModel } from 'src/app/models/reto/transaccion.model';

export const TRANSACCIONES_FORM_SUPPORT_DATA_KEYS = {
    productos: 'productos',
    entidades: 'entidades',
    clientes: 'clientes',
} as const;

export type TransaccionesFormSupportDataKey =
    typeof TRANSACCIONES_FORM_SUPPORT_DATA_KEYS[keyof typeof TRANSACCIONES_FORM_SUPPORT_DATA_KEYS];

export interface TransaccionesFormLoadPlanOptions {
    readonly hasClients: boolean;
}

/** Defines the support-data loading phases for the transaction form. */
export class TransaccionesFormLoadPlan {
    public static createSupportDataSources(
        options: TransaccionesFormLoadPlanOptions,
    ): readonly ReactiveFormSupportDataSource<TransaccionModel>[] {
        const sources: ReactiveFormSupportDataSource<TransaccionModel>[] = [
            TransaccionesFormLoadPlan.createSource(TRANSACCIONES_FORM_SUPPORT_DATA_KEYS.productos, 'critical'),
            TransaccionesFormLoadPlan.createSource(TRANSACCIONES_FORM_SUPPORT_DATA_KEYS.entidades, 'critical'),
        ];

        if (options.hasClients) {
            sources.push(TransaccionesFormLoadPlan.createSource(TRANSACCIONES_FORM_SUPPORT_DATA_KEYS.clientes, 'critical'));
        }

        return sources;
    }

    private static createSource(
        key: TransaccionesFormSupportDataKey,
        phase: ReactiveFormSupportDataPhase,
    ): ReactiveFormSupportDataSource<TransaccionModel> {
        return {
            key,
            phase,
            load: () => undefined,
        };
    }
}
